/**
 * The house modal, which the dialog and the alert dialog both draw, so the two
 * cannot drift. It sits in the middle of the window, held there by auto
 * margins on all four sides, since the enter animation writes the transform.
 * Neither animates for someone whose system asks for less motion.
 */
export const MODAL_OVERLAY =
  "fixed inset-0 z-50 bg-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 motion-reduce:animate-none";

export const MODAL_SURFACE =
  "fixed inset-0 z-50 m-auto grid h-fit max-h-[calc(100vh-48px)] w-[calc(100%-48px)] max-w-[440px] gap-4 overflow-y-auto rounded-lg border border-border bg-card px-[22px] pt-[22px] pb-[18px] shadow-dialog duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 motion-reduce:animate-none";

export const MODAL_TITLE =
  "text-[17px] leading-[1.3] font-bold tracking-[-0.01em]";

export const MODAL_DESCRIPTION =
  "text-detail leading-normal text-muted-foreground";

// 22px under the body: the grid's 16 and six more. The design's modal buttons
// are a size of their own, roomier than a row's, so the foot sets them.
export const MODAL_ACTIONS =
  "flex flex-wrap justify-end gap-[9px] pt-1.5 [&_button]:h-auto [&_button]:rounded-inset [&_button]:px-4 [&_button]:py-[9px] [&_button]:text-detail";
